import React from "react";
import { translate } from "react-i18next";
import colors from "../../../../styles/colors";

import { Container, YesNoLabel } from "./styles";
import { Input } from "../../../../styles/defaults";

const YesNo = ({ t, response, onValueChange, onClick, guid, questionIndexToModel }) => (
  <Container>
    <Input
      type="radio"
      name="yesorno"
      id={`yes-${questionIndexToModel}-${guid}`}
      value={1}
      onChange={({ target }) =>
        onValueChange({ response: parseInt(target.value) })
      }
      onClick={({ target }) => onClick(target.value)}
    />
    <YesNoLabel
      checked={parseInt(response) === 1}
      selected={response}
      bgColor={colors.positive}
      htmlFor={`yes-${questionIndexToModel}-${guid}`}
    >
      {t("yes")}
    </YesNoLabel>

    <Input
      type="radio"
      name="yesorno"
      id={`no-${questionIndexToModel}-${guid}`}
      value={2}
      onChange={({ target }) =>
        onValueChange({ response: parseInt(target.value) })
      }
      onClick={({ target }) => onClick(target.value)}
    />
    <YesNoLabel
      checked={parseInt(response) === 2}
      selected={response}
      bgColor={colors.negative}
      htmlFor={`no-${questionIndexToModel}-${guid}`}
    >
      {t("no")}
    </YesNoLabel>
  </Container>
);

export default translate("translations")(YesNo);
